"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "15",
    height: "16",
    viewBox: "0 0 15 16"
  }), " ", /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M10.0019531,2.9824276 L6.21875,2.98242774 C2.796875,2.98242774 6.10591576e-16,5.85919542 3.92876589e-16,9.41475097 C1.75161603e-16,12.9703065 2.796875,15.8309126 6.21875,15.8309126 C9.640625,15.8309126 12.4838257,13.5352313 12.4838257,9.97967577 L9.73480225,9.97967577 C9.73480225,11.9998778 8.1875,13.0834378 6.21875,13.0834378 C4.25,13.0834378 2.65625,11.434953 2.65625,9.39858936 C2.65625,7.36222572 4.25,5.99700928 6.21875,5.99700928 L10.0019531,5.99700928 L10.0019531,8.73040819 L14.9375,4.35616512 L10.0019531,1.13686838e-13 L10.0019531,2.9824276 L10.0019531,2.9824276 Z"
  }), " ");
};

exports["default"] = _default;